import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

const VEHICLE_RESOURCE = "vehicle" as const;
export const VEHICLE_VALUATION_SYNC_DAT_DATA_OPERATION = "sync-dat-data" as const;
export const VEHICLE_VALUATION_SYNC_DAT_DATA_API_PATH =
  `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/${VEHICLE_VALUATION_SYNC_DAT_DATA_OPERATION}` as const;

export type VehicleValuationSyncDatDataResponse =
  paths[typeof VEHICLE_VALUATION_SYNC_DAT_DATA_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useVehicleValuationSyncDatDataMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationSyncDatDataResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<VehicleValuationSyncDatDataResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}/${VEHICLE_VALUATION_SYNC_DAT_DATA_OPERATION}`,
      );

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
        }),
      ]);
    },
  });
};
